// extracted by mini-css-extract-plugin
module.exports = {"halfWidth":"data-annotation_halfWidth__3eNu5"};